import Vue from 'vue'
import $ from 'jquery'
import Scrollable from './scrollable.js'

class Section extends Scrollable {

	mounted() {
		super.mounted()

	}

	init() {

		super.init()
		
	}

	_resize() {


	}

}

export default Section


// WEBPACK FOOTER //
// ./src/abstracts/section.js